import React from 'react';
import AuthService from '../../services/AuthService';

const SimpleQuoteLink = ({ quote, ...rest }) => {
  const label = `Q${String(quote.id)}`;

  if (!AuthService.hasPermission('EQS1')) {
    return <div {...rest}>{label}</div>;
  }

  return (
    <div {...rest}>
      <a href={`/db/EQS2/${quote.dealId}/edit/${quote.id}`}>{label}</a>
    </div>
  );
};

export default SimpleQuoteLink;
